/** 
 * @props dataObj: object containing any kind of data that you want to pass it to process when the element is dropped.
 * @props children: the element structure and you want to make draggable
*/

import React from 'react';

const onDragStart = (e, dataObj) => {
    e.dataTransfer.setData("dataObj", JSON.stringify(dataObj));
}
const onDragEnd = (e) => {
    e.preventDefault();
}

export default function DraggableItem({ dataObj, children }) {
    return (
        <div draggable onDragStart={(e) => onDragStart(e, dataObj)} onDragEnd={(e) => onDragEnd(e)}>
            {children}
        </div>
    );
};
